import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import { tributesApi } from '../../services/api';

const AdminTributesPage = () => {
  const token = localStorage.getItem('adminToken');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      const data = await tributesApi.getPending({ limit: 50 }, token);
      setItems(data.tributes || []);
    } catch (err) {
      setError(err.message || 'تعذر تحميل كلمات الرثاء');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (!token) {
      window.location.href = '/admin/login';
      return;
    }
    fetchItems();
  }, [token, fetchItems]);

  const handleApprove = async (id) => {
    try {
      await tributesApi.approve(id, token);
      fetchItems();
    } catch (err) {
      setError(err.message || 'تعذر الموافقة');
    }
  };

  const handleReject = async (id) => {
    if (!window.confirm('هل تريد رفض وحذف هذه الكلمة؟')) return;
    try {
      await tributesApi.reject(id, token);
      fetchItems();
    } catch (err) {
      setError(err.message || 'تعذر الرفض');
    }
  };

  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Header />
      <main className="section-padding">
        <div className="container-responsive max-w-4xl">
          <h1 className="text-responsive-3xl font-bold text-primary-800 mb-2">كلمات الرثاء</h1>
          <p className="text-gray-600 mb-8">مراجعة كلمات الزوار قبل نشرها في صفحة الشهيد</p>
          {error && <div className="mb-4 p-4 rounded-lg bg-red-50 text-red-700">{error}</div>}
          {loading ? (
            <p>جاري التحميل...</p>
          ) : items.length === 0 ? (
            <p className="text-gray-500">لا توجد كلمات بانتظار المراجعة</p>
          ) : (
            <div className="space-y-4">
              {items.map((item) => (
                <div key={item.id} className="card">
                  <div className="card-body">
                    <p className="text-sm text-primary-700 mb-2">
                      عن الشهيد:{' '}
                      <Link to={`/martyr/${item.martyr_id}`} className="underline">{item.martyr_name}</Link>
                    </p>
                    <p className="font-bold">{item.visitor_name}</p>
                    <p className="text-gray-700 mt-2 leading-relaxed">{item.message}</p>
                    <div className="flex gap-2 mt-4">
                      <button className="btn btn-success btn-sm" onClick={() => handleApprove(item.id)}>موافقة</button>
                      <button className="btn btn-error btn-sm" onClick={() => handleReject(item.id)}>رفض</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AdminTributesPage;
